import { connect } from "react-redux";
import LimitedVisibility from "./LimitedVisibility";


const mapStateToProps = (state) => ({

    fetchCantAnswerResponseApi: state.BenchmarkFilteringReducer.fetchCantAnswerResponseApi

});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(LimitedVisibility);
